import { render, staticRenderFns } from "./ChangePhone.vue?vue&type=template&id=2451097b&scoped=true"
import script from "./ChangePhone.vue?vue&type=script&lang=js"
export * from "./ChangePhone.vue?vue&type=script&lang=js"
import style0 from "./ChangePhone.vue?vue&type=style&index=0&id=2451097b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2451097b",
  null
  
)

export default component.exports